export default "/images/b5d53790e88060cf1f2049d123b091b9.avif";